module.exports = __webpack_public_path__ + "static/img/zhidong.c5ac25cc.svg";